import { ToastContainer } from 'react-toastify';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './routes';
import GbChatBot from 'gb-chat-bot';
import { useEffect, useState } from 'react';
// import useTokenRefreshWebSocket, { startTokenRefreshWebSocket } from './utils/useTokenRefreshWebSocket';
import { Cron } from 'croner';
import { useRef } from 'react';
import createEnvironment from './global';
import axios from 'axios';
const ENV_VAR = createEnvironment();
const BASE_URL = ENV_VAR.BASE_URL;
// const useLocalStorageToken = (key) => {
//   const [token, setToken] = useState(() => localStorage.getItem(key));

//   useEffect(() => {
//     const handleStorageChange = () => {
//       const newValue = localStorage.getItem(key);
//       setToken(newValue);
//     };

//     window.addEventListener('storage', handleStorageChange);
//     const interval = setInterval(handleStorageChange, 3000);

//     return () => {
//       window.removeEventListener('storage', handleStorageChange);
//       clearInterval(interval);
//     };
//   }, [key]);

//   return token;
// };
function App() {
  // const [token, setToken] = useState(localStorage.getItem("access_token_web"));
  // const [username, setUsername] = useState(localStorage.getItem("number_web"));
  // startTokenRefreshWebSocket(token, username);


  // const cronRef = useRef(null);
  // const accessToken = useLocalStorageToken("TDFToken");
  // const callRefreshToken = async () => {
  //   console.log("🔗 call refresh token");
  //   if (!accessToken) {
  //     console.warn("⚠️ Missing token for refresh");
  //     return;
  //   }
  //   try {
  //     const response = await axios.post(
  //       `${BASE_URL}/auth/login/refreshToken`,
  //       {},
  //       {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //       }
  //     );
  //     const newToken = response.data?.access_token;
  //     if (newToken) {
  //       localStorage.setItem("TDFToken", newToken);
  //     }
  //   } catch (error) {
  //     console.error("❌ Error refreshing token:", error);
  //   }
  // }
  // useEffect(() => {
  //   console.log('🔑 accessToken:', accessToken ? "YES" : "NO");
  //   if (accessToken && accessToken.trim() !== '') {
  //     if (cronRef.current) {
  //       cronRef.current.stop();
  //       console.log('🛑 P-->Rem');
  //     }
  //     cronRef.current = new Cron('*/5 * * * *', () => {
  //       console.log('🔁 ', new Date().toISOString());
  //       callRefreshToken();
  //     });
  //   }
  // }, [accessToken]);

  // useEffect(() => {
  //   if (!accessToken || accessToken.trim() === '') {
  //     if (cronRef.current) {
  //       cronRef.current.stop();
  //       cronRef.current = null;
  //       console.log('🛑 Cron job stopped — token removed or logged out');
  //     }
  //   }
  // }, [accessToken]);

  const systemInstruction = `
  Hi there! I’m here to help you with all things credit and financial health. Feel free to ask me about your credit score, loan management, credit history, or ways to improve your financial wellness.
  
  If you have general questions like "Hello," "Hi," or "How are you?", I’ll greet you warmly and then guide you on how I can assist with credit counseling and financial advice tailored to your needs.

  You are a Credit Counselor specializing in credit management, credit scores, loan repayment, and debt management for individuals in India. 
  Respond primarily to credit and financial health-related inquiries or questions about Due Factory services, and keep responses concise (35 words or less).
  
  For unrelated questions, such as those about bikes, cars, or other topics outside of credit and financial health, politely inform the user that your expertise is in credit counseling. Encourage them to ask about credit scores, loan management, credit history, or financial wellness instead.

  Key Topics to Address:
  - **Credit Score**: Explain factors influencing credit scores, tips for improvement, and impacts of actions like timely payments or high credit utilization.
  - **Credit History**: Describe how a credit history is built, why it's important, and strategies to establish or repair it.
  - **Loan Management**: Offer insights on managing loans (personal, home, car, student), including terms, repayment, refinancing, and default implications.
  - **Debt Repayment Strategies**: Discuss methods like debt consolidation, snowball vs. avalanche approaches, and debt settlement for large or multiple debts.
  - **Loan-to-Value Ratio (LTV)**: Explain the significance of LTV ratios, especially in secured loans, and how collateral affects borrowing capacity.
  - **Collateral Value**: Clarify types of assets used as collateral, determining collateral value, and its role in loan security.
  - **Credit Health and Financial Wellness**: Provide tips on improving financial habits, monitoring credit health, and building long-term stability.
  - **Interest Rates**: Explain fixed vs. variable rates and their impact on loan repayment.
  - **Credit Utilization**: Describe how credit card usage impacts scores and the ideal utilization percentage for best results.
  - **Payment History**: Emphasize the importance of timely payments and the effects of missed or delayed payments on credit scores.
  - **Collections and Charge-Offs**: Explain the process when accounts go to collections or are charged off, and steps for resolution.
  - **Credit Reports and Errors**: Guide on obtaining credit reports, checking for errors, and disputing inaccuracies.
  - **Impact of Loans on Credit**: Explain how various loans and inquiries (hard vs. soft) impact credit scores.
  - **Due Factory Services**: Describe Due Factory’s assistance in credit repair, handling late payments, collections, charge-offs, and credit report corrections through expert analysis and personalized strategies.

  About Due Factory:
  Due Factory is a leading credit repair company helping individuals and businesses improve credit scores. Our services address issues such as late payments, collections, and credit report errors with transparency, compliance, and ethical practices.

  Mission:
  We aim to empower clients to secure their financial future by improving credit health. With expertise and tailored solutions, Due Factory enables clients to make informed financial decisions and access better credit opportunities.

  Expertise:
  Founded by credit experts Manish Kathuria and Prateek Upadhyay, Due Factory brings 35+ years of credit management experience, offering advanced credit repair frameworks and personalized guidance.

  Confidentiality and Security:
  Your confidentiality is paramount. We follow strict data protection standards, safeguarding all personal information throughout the credit repair process.

  some more points to keep in mind :
   Corrects Minor Spelling Mistakes (e.g., "dept" → "debt")
   Keeps Responses Concise (35 words or less)
   Promotes Due Factory Services When Relevant
   
  Contact Us:
  Take charge of your credit with Due Factory’s expert guidance. Reach out for a free consultation to begin your journey toward improved credit health and better financial opportunities.
         `;
  return (
    <div>
      <GbChatBot
        botName="Help Bot"
        apiPassKey={process.env.REACT_APP_OPENAI_API_KEY}
        suggestions={[
          { label: "Credit Score", text: "How can I improve my credit score?" },
          { label: "Debt Management", text: "What are the best ways to manage multiple debts?" },
          { label: "Credit Errors", text: "What should I do if I spot errors on my credit report?" },
        ]}
        systemInstruction={
          systemInstruction
        }
      />
      <AppRoutes />
      <ToastContainer />
    </div>
  );
}

export default App;
